var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.14286 2V18M14.5714 8.85714H10.5714M14.5714 5.42857H10.5714M4.28571 5.42857H2M4.28571 8.85714H2M4.28571 12.2857H2M5.42857 18H15.7143C16.9766 18 18 16.9766 18 15.7143V4.28571C18 3.02335 16.9766 2 15.7143 2H5.42857C4.16621 2 3.14286 3.02335 3.14286 4.28571V15.7143C3.14286 16.9766 4.16621 18 5.42857 18Z",
    stroke: "#0E1111",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.0e43eb9254c7b4be1a1babaab0614a33.svg";
export { ForwardRef as ReactComponent };